import './App.scss';
import ProjectRouter from './router';

function App() {
  return <div className='app'>{ProjectRouter()}</div>;
}

export default App;
